import { render } from "./NodeChatTypeItem.vue?vue&type=template&id=39b6b5e3"
import script from "./NodeChatTypeItem.vue?vue&type=script&lang=js"
export * from "./NodeChatTypeItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"NodeChatTypeItem.vue"]])

export default __exports__